import Title from '@cohort/components-xps/components/Title';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {Disclosure} from '@headlessui/react';
import {CaretDown} from '@phosphor-icons/react';
import type {FC} from 'react';
import {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

export const AboutMerchant: FC = () => {
  const {space} = useSpaceContext();
  const {t} = useTranslation('components', {keyPrefix: 'space.aboutMerchant'});
  const {hasDarkBg, accentColor} = useThemeContext();

  if (space === undefined) {
    return <Fragment />; // Replace me by a skeleton loader.
  }

  const {merchant} = space;

  if (!merchant.description) {
    return <Fragment />;
  }

  return (
    <div className="flex w-full flex-grow-0 flex-col gap-y-4">
      <Disclosure as="div" key="aboutMerchant" defaultOpen>
        {({open}) => (
          <Fragment>
            <Disclosure.Button
              as="div"
              onClick={() => {}}
              className="flex w-full cursor-pointer items-center justify-between py-2 text-left md:py-4"
            >
              <Title classes="text-2xl" content={t('title')} />
              <div style={{color: accentColor}} className="ml-6 flex h-7 items-center">
                <CaretDown
                  className={classNames(
                    'h-6 w-6 transform duration-200',
                    open ? '-rotate-0' : '-rotate-90'
                  )}
                  aria-hidden="true"
                />
              </div>
            </Disclosure.Button>

            <Disclosure.Panel as="div" className="w-full">
              <p
                className={classNames('prose', hasDarkBg && 'prose-invert')}
                dangerouslySetInnerHTML={{
                  __html: merchant.description ?? '',
                }}
              />
            </Disclosure.Panel>
          </Fragment>
        )}
      </Disclosure>
    </div>
  );
};
